import { useDispatch } from 'react-redux';
import { replace } from 'redux-first-history';
import { Url } from '@rossum/api-client';
import { constructDocumentUrl } from '../../lib/url';
import { cancelAnnotation } from '../../redux/modules/annotation/actions';

type UseLeaveEditModeParams = {
  annotationUrl: Url | undefined;
  currentAnnotationId: number;
  /**
   * Resolves the location to leave to. Called lazily on leave, because the
   * destination depends on state that can change after render (router state,
   * stored backlink).
   */
  getDestination: () => string;
};

export const useLeaveEditMode = ({
  annotationUrl,
  currentAnnotationId,
  getDestination,
}: UseLeaveEditModeParams) => {
  const dispatch = useDispatch();

  return () => {
    const destination = getDestination();

    const isGoingToCurrentAnnotation =
      destination === constructDocumentUrl({ id: currentAnnotationId });

    if (!isGoingToCurrentAnnotation && annotationUrl) {
      dispatch(cancelAnnotation(annotationUrl));
    }

    dispatch(replace(destination));
  };
};
